import { Text, Badge, Tooltip } from "@mantine/core"
import { WorkAreaTargetAndCurrentAssignedRolesSums } from "../../../../../../@client/Theasoft_ApiServer_Orchestra"
import { useTranslation } from "react-i18next"
import css from "./cells.module.css"

export function WorkareaHeaderCell(props: { children?: React.ReactNode }) {
  return (
    <div className={css["workarea-target-roles-cell"]}>{props.children}</div>
  )
}
export function WorkAreaStatisticsCell({
  data,
}: {
  data: WorkAreaTargetAndCurrentAssignedRolesSums | undefined
}) {
  return (
    <WorkareaHeaderCell>
      {data && data.roleCountTarget != 0 ? (
        <StatisticsBadge
          description={data.description}
          currentlyAssigned={data.currentlyAssignedRoleCount}
          target={data.roleCountTarget}
        />
      ) : null}
    </WorkareaHeaderCell>
  )
}

function StatisticsBadge({
  target,
  currentlyAssigned,
  description,
}: {
  target: number
  currentlyAssigned: number
  description: string
}) {
  const diff = currentlyAssigned - target
  const { t } = useTranslation("app_server")
  return (
    <Tooltip
      label={
        <>
          <Text>{description}</Text>
          <Text>
            {t("NumberRequiredCastsInRole")}: {target}
          </Text>
          <Text>
            {" "}
            {t("NumberCurrentCastsInRole")}: {currentlyAssigned}
          </Text>
          {diff > 0 ? (
            <Text>
              {t("ThereAreMoreCastsThanRequired")}: + {diff}
            </Text>
          ) : null}
          {diff < 0 ? (
            <Text>
              {t("ThereAreCastsMissing")}: {-diff}
            </Text>
          ) : null}
        </>
      }
    >
      <Badge
        style={{ justifSelf: "center", alignSelf: "center" }}
        size={"xs"}
        color={diff >= 0 ? "green" : "red"}
      >
        <Text fw={diff > 0 ? "bold" : undefined} size="xs" c="white">
          {currentlyAssigned}/{target}
          {diff > 0 ? `!` : null}
        </Text>
      </Badge>
    </Tooltip>
  )
}
